import { render, staticRenderFns } from "./ChatSectionModal.vue?vue&type=template&id=5193d7b7&"
import script from "./ChatSectionModal.vue?vue&type=script&lang=js&"
export * from "./ChatSectionModal.vue?vue&type=script&lang=js&"
import style0 from "./ChatSectionModal.vue?vue&type=style&index=0&id=5193d7b7&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports